var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"893a52da9764d58e2734bdc25b892e23e807c7b8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["goals-wizard@success-wizard"]={id:"893a52da9764d58e2734bdc25b892e23e807c7b8"};
      